import { apiFetch } from "../api";
import { BASE_URL } from "../../commonUrls";

const BASE = `${BASE_URL}/admin`;

export async function fetchUsers(query, limit = 50) {
  const params = new URLSearchParams();
  if (query) params.append("query", query);
  if (limit) params.append("limit", String(limit));
  const res = await apiFetch(`${BASE}/users?${params.toString()}`);
  return res.json();
}

export async function fetchUserSummary(userId) {
  const res = await apiFetch(`${BASE}/users/${userId}/summary`);
  return res.json();
}

export async function setUserEnabled(userId, enabled) {
  const path = enabled ? "enable" : "disable";
  return apiFetch(`${BASE}/users/${userId}/${path}`, { method: "POST" });
}

export async function setUserLocked(userId, locked) {
  const path = locked ? "lock" : "unlock";
  return apiFetch(`${BASE}/users/${userId}/${path}`, { method: "POST" });
}

export async function resetUserPassword(userId, tempPassword) {
  const res = await apiFetch(`${BASE}/users/${userId}/reset-password`, {
    method: "POST",
    body: JSON.stringify({ tempPassword }),
  });
  return res.json();
}

export async function updateUserRole(userId, role) {
  return apiFetch(`${BASE}/users/${userId}/role`, {
    method: "POST",
    body: JSON.stringify({ role }),
  });
}

export async function fetchAudit(params = {}) {
  const search = new URLSearchParams(params);
  const res = await apiFetch(`${BASE}/audit?${search.toString()}`);
  return res.json();
}

export async function fetchHealth() {
  const res = await apiFetch(`${BASE}/health`);
  return res.json();
}

export async function fetchJobs() {
  const res = await apiFetch(`${BASE}/jobs`);
  return res.json();
}

export async function triggerJob(jobKey) {
  return apiFetch(`${BASE}/jobs/${jobKey}/trigger`, { method: "POST" });
}

export async function setJobEnabled(jobKey, enabled) {
  return apiFetch(`${BASE}/jobs/${jobKey}/enable?enabled=${enabled}`, { method: "POST" });
}

export async function fetchSettings() {
  const res = await apiFetch(`${BASE}/settings`);
  return res.json();
}

export async function upsertSetting(key, value) {
  const res = await apiFetch(`${BASE}/settings/${encodeURIComponent(key)}`, {
    method: "PUT",
    body: JSON.stringify({ key, value }),
  });
  return res.json();
}

export async function exportUser(userId) {
  const res = await apiFetch(`${BASE}/export/users/${userId}`);
  return res.json();
}

export async function fetchIncidentReport() {
  const res = await apiFetch(`${BASE}/incident/report`);
  return res.json();
}

export async function fetchRoles() {
  const res = await apiFetch(`${BASE}/roles`);
  return res.json();
}

export async function updateRolePermissions(role, permissions) {
  const res = await apiFetch(`${BASE}/roles/${role}`, {
    method: "PUT",
    body: JSON.stringify({ permissions }),
  });
  return res.json();
}
